import React from "react";
import PropTypes from "prop-types";
import CircleButton from "../commons/CircleButton";
import { hideModal } from "../../../usecases/commons/hide-modal";
import { translate } from "../../../infrastructure/translate/localization";

function ConfirmationModal({ message, onConfirm }) {
  return (
    <div className="modal-container">
      <CircleButton
        className="primary close-modal"
        icon="times"
        handlerClick={() => hideModal()}
      />
      <div className="modal-content">
        <div className="modal-left-line" />
        <span className="message">{message}</span>
        <div className="cob-btn-group center-group">
          <button
            type="button"
            className="cob-btn btn-primary-outline"
            onClick={() => hideModal()}
          >
            {translate("actions.cancel")}
          </button>
          <button
            type="button"
            className="cob-btn"
            onClick={() => onConfirm() && hideModal()}
          >
            {translate("actions.confirm")}
          </button>
        </div>
      </div>
    </div>
  );
}

ConfirmationModal.defaultProps = {};
ConfirmationModal.propTypes = {
  message: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmationModal;
